module.exports = __webpack_public_path__ + "static/media/sponsor-706.20d12dca.png";